<template>
  <div
    style="
      width: 100%;
      display: flex;
      align-items: flex-end;
      flex-direction: column;
      position: fixed;
      z-index: 100;
    "
  >
    <audio ref="audio" src="/bgm/BeatThee.mp3"></audio>
    <img
      style="height: 6vw; width: 6vw; margin: 5px;"
      v-on:click="playOrStopMusic"
      :src="imgSrc"
      alt="MP3"
    />
  </div>
</template>

<script>
export default {
  name: 'musicIcon',
  data() {
    return {
      isPlaying: false,
      imgSrc: '/svg/pause.svg',
    }
  },
  methods: {
    playOrStopMusic() {
      if (this.isPlaying === true) {
        this.$refs.audio.pause()
        this.imgSrc = '/svg/pause.svg'
        this.isPlaying = false
      } else if (this.isPlaying === false) {
        this.$refs.audio.play()
        this.imgSrc = '/svg/play.svg'
        this.isPlaying = true
      }
    },
  },
}
</script>

<style scoped></style>
